require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-majesty-dominguez.json") })
        }
      }, "path---member-majesty-dominguez");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-majesty-dominguez!./.cache/json/member-majesty-dominguez.json
// module id = 402
// module chunks = 231608221292675